<header class="masthead">
	<div class="navbar">
		<div class="left-header" style="margin-left: 12px; position: relative">
				<button style="width: 260px;" id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon">
					<a (click)="backToWorkspace()" class="navbar-brand js-scroll-trigger left-header-backpress" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
				<div class="lib-icon-red">
					<img src="assets/img/lib-icon-red.svg">
				</div>
				<h4 class="content-lib-txt">Content Library</h4>
				<span class="beta-pro" style="right: -10px;">
					Beta
				</span>
			</button>
		</div>

		<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
			<div class="center-header">
				<div class="search-box" id="search-box">
					<button>
						<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="24px" height="24px" fill="#888888" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
					</button>

					<input style="width: 100%;" type="text" placeholder="Type here to search library by title, tags..." class="text-field" name="searchText" [(ngModel)]="searchText"/>
					<input style="display: none" type="Submit" value="Search" class="button">
				</div>
			</div>
		</form>

		<div class="right-header">
			<div class="menu-pop-over anticon-bell">
				<a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<!-- <div class="" *ngIf="showLoader">
									<img src="assets/img/loader.svg" style="margin-left: auto;margin-right: auto;display: block;width: 30%;" alt="">
								</div> -->

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>


								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
											<div>
												<div class="user-info-name">
													<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
												</div>
												<div class="" style="margin-top: 4px;">
													<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
								<!-- <span class="pro">
									BETA
								</span> -->
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goToSubscription()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section *ngIf="librarySection">
	<div class="main-container">
		<div class="center-container vectors-section" style="padding-left: 50px;">
			<div class="">
				<div class="homepage-heading">
					<div class="homepage-heading_">
						<div class="homepage-heading-title">
							<h4 class="lib-library-txt" [ngClass]="{'selected-lib-text': isSelected[0], 'unselected-lib-text': !isSelected[0]}" (click)="myLibraryClick(0)">My Library</h4>
							<h4 class="lib-discover-txt" [ngClass]="{'selected-lib-text': isSelected[1], 'unselected-lib-text': !isSelected[1]}" (click)="discoverClick(1)">Discover</h4>
							<h4 *ngIf="searchLibrarySection" class="lib-discover-txt" [ngClass]="{'selected-lib-text': isSelected[2], 'unselected-lib-text': !isSelected[2]}">Search</h4>
						</div>

						<label *ngIf="showMyLibrary && planName == 'Free'" style="height: 42px; display: flex; align-items: center; justify-content: center;" class="custom-file-upload" mat-raised-button #tooltip="matTooltip"
						matTooltip="Add library content"
						matTooltipPosition="above"
						matTooltipClass="custom-tooltip" (click)="openGoProDialog()">
							<svg style="margin-right: 10px; margin-top:-4px" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
											<g id="DAM-Landing-Page-Copy-4" transform="translate(-1312.000000, -111.000000)">
													<g id="CTA-Copy-3" transform="translate(1296.000000, 96.000000)">
															<g id="Add" transform="translate(16.000000, 15.000000)">
																	<rect id="Rectangle" x="0" y="0" width="18" height="18" rx="4"></rect>
																	<g id="Group-3" transform="translate(3.000000, 3.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
																			<line x1="6" y1="0" x2="6" y2="12" id="Path-8"></line>
																			<line x1="6" y1="0.315789474" x2="6" y2="11.6842105" id="Path-8-Copy" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></line>
																	</g>
															</g>
													</g>
											</g>
									</g>
							</svg>
							<span>Add</span>
						</label>

						<label *ngIf="showMyLibrary && planName != 'Free'" style="height: 42px; display: flex; align-items: center; justify-content: center;" class="custom-file-upload" mat-raised-button #tooltip="matTooltip"
						matTooltip="Add library content"
						matTooltipPosition="above"
						matTooltipClass="custom-tooltip" (click)="openContentDialog('Add', '', '', '', '', '')">
							<svg style="margin-right: 10px; margin-top:-4px" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
											<g id="DAM-Landing-Page-Copy-4" transform="translate(-1312.000000, -111.000000)">
													<g id="CTA-Copy-3" transform="translate(1296.000000, 96.000000)">
															<g id="Add" transform="translate(16.000000, 15.000000)">
																	<rect id="Rectangle" x="0" y="0" width="18" height="18" rx="4"></rect>
																	<g id="Group-3" transform="translate(3.000000, 3.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
																			<line x1="6" y1="0" x2="6" y2="12" id="Path-8"></line>
																			<line x1="6" y1="0.315789474" x2="6" y2="11.6842105" id="Path-8-Copy" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></line>
																	</g>
															</g>
													</g>
											</g>
									</g>
							</svg>
							<span>Add</span>
						</label>

						<!-- <label *ngIf="showDiscover && discoverList.length > 0" style="height: 42px; display: flex; align-items: center; justify-content: center;" class="custom-file-upload">

							<span>Add to library</span>
						</label> -->
					</div>
				</div>

				<div class="library-section" *ngIf="showMyLibrary">

					<div class="no-illus-img" *ngIf="libraryContent">
						<img style="width: 200px;" src="assets/img/lost.png">
						<div><label>Explore discover tab or add your own content!</label></div>
					</div>

					<div class="row">
						<div class="team-div" *ngIf="!libraryContent">
							<ul *ngFor="let textContent of libraryContentList; let i = index">
								<li style="width: 100%;">
									<div class="library-main-area">

										<label *ngIf="!imageSelected" class="ill-add-btn-discover select-illus" [style.background-color] = "changeColors[i]  ? '#ffffff' : '#e4e4e4'">
										<input type="checkbox" value="illus_2" id="illus_2" class="d-none custom-control-input" (click)="changeColors[i]=!changeColors[i]; showDeleteFromLibButtons(changeColors[i], i, textContent)">
										<span class="anticon anticon-check">
										</span></label>
										<label *ngIf="imageSelected" class="ill-add-btn-team-discover select-illus" [style.background-color] = "changeColors[i]  ? 'green' : '#e4e4e4'">
										<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColors[i]=!changeColors[i]; showDeleteFromLibButtons(changeColors[i], i, textContent)">
										<span class="anticon anticon-check">
											<svg *ngIf="changeColors[i] == false" viewBox="64 64 896 896" focusable="false" class="nike-mark" data-icon="check" width="1em" height="1em" fill="#e4e4e4" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
											<svg *ngIf="changeColors[i] == true" viewBox="64 64 896 896" focusable="false" class="nike-mark-show" data-icon="check" width="1em" height="1em" fill="white" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
										</span></label>

										<div class="img-area" *ngIf="textContent.owner == 'Crafttor'">
											<img src="assets/img/crafttor-lib.svg" class="crafttor-lib-img">
										</div>

										<div data-toggle="dropdown" class="three-dots-area">
											<span class="anticon img-more-options">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="6" cy="12" r="2" fill="#ffffff"/>
												<circle cx="12" cy="12" r="2" fill="#ffffff"/>
												<circle cx="18" cy="12" r="2" fill="#ffffff"/>
												</svg>
											</span>

											<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="more-option-section" (click)="openLibEditTagsDialog(textContent.id, textContent)">
														 <img src="assets/img/edit-icon.svg" alt="">
														 <a class="text" href="javscript:;" style="margin-top: 3px;">Edit tags</a>
													 </li>

													 <li class="more-option-section" *ngIf="textContent.owner == 'Crafttor'" (click)="deleteLibraryContent(textContent.id)">
														 <img src="assets/img/delete-red.svg" alt="">
														 <a style="color: #eb1313; margin-top: 2px;" class="text" href="javscript:;">Remove</a>
													 </li>

													 <li class="more-option-section" *ngIf="textContent.owner != 'Crafttor'" (click)="deleteLibraryContent(textContent.id)">
														 <img src="assets/img/delete-red.svg" alt="">
														 <a style="color: #eb1313; margin-top: 2px;" class="text" href="javscript:;">Delete</a>
													 </li>
													</ul>
											</div>
										</div>

										<div class="text-center" (click)="toggleLibraryContent(textContent.content_data, textContent.type)">
											<div *ngIf="!textContent.cover_image && textContent.type == 'text'" class="lib-img-center">
												<img style="width: auto" src="assets/img/lib-content.png" alt="">
											</div>

											<div *ngIf="!textContent.cover_image && textContent.type == 'image_file'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + textContent.content_data[0].image + ')' }"></div>

											<div *ngIf="textContent.cover_image && textContent.type == 'text'" style="display: flex; justify-content: center; align-items: center;" class="lib-img-center">
											  <span style="font-size: 50px;" class="emoji-icon">{{ convertUnicodeToEmoji(textContent.cover_image) }}</span>
											</div>

											<div *ngIf="textContent.cover_image && textContent.type == 'image_url'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + textContent.cover_image + ')' }"></div>

											<div class="lib-user-info-name">
												<span class="content-title">{{textContent.title}}</span>

												<span class="content-counts">{{textContent.content_data.length}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="library-section" *ngIf="showDiscover">
					<div class="row">
						<div class="team-div">
							<ul *ngFor="let discoverContent of discoverContentList; let i = index">
								<li style="width: 100%;">
									 <!-- [class.selected]="discoverContent.selected" -->
									<div class="library-main-area">

										<label style="cursor: default;" *ngIf="discoverContent.isAddedToMyLibrary" class="ill-add-btn-team-discover select-illus" [style.background-color] = "'#2d7cff'">
										<input type="checkbox" value="illus_2" id="illus_2" class="d-none">
										<span class="anticon anticon-check">
											<svg viewBox="64 64 896 896" focusable="false" class="nike-mark-show" data-icon="check" width="1em" height="1em" fill="white" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
										</span></label>

										<label *ngIf="!imageSelected && !discoverContent.isAddedToMyLibrary" class="ill-add-btn-discover select-illus" [style.background-color] = "changeColor[i]  ? '#ffffff' : '#e4e4e4'">
										<input type="checkbox" value="illus_2" id="illus_2" class="d-none custom-control-input" (click)="changeColor[i]=!changeColor[i]; showAddToLibButtons(changeColor[i], i, discoverContent)">
										<span class="anticon anticon-check">
										</span></label>
										<label *ngIf="imageSelected && !discoverContent.isAddedToMyLibrary" class="ill-add-btn-team-discover select-illus" [style.background-color] = "changeColor[i]  ? 'green' : '#e4e4e4'">
										<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColor[i]=!changeColor[i]; showAddToLibButtons(changeColor[i], i, discoverContent)">
										<span class="anticon anticon-check">
											<svg *ngIf="changeColor[i] == false" viewBox="64 64 896 896" focusable="false" class="nike-mark" data-icon="check" width="1em" height="1em" fill="#e4e4e4" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
											<svg *ngIf="changeColor[i] == true" viewBox="64 64 896 896" focusable="false" class="nike-mark-show" data-icon="check" width="1em" height="1em" fill="white" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
										</span></label>

										<div class="text-center" (click)="toggleLibraryContent(discoverContent.content_data, discoverContent.type)">
											<div *ngIf="!discoverContent.cover_image && discoverContent.type == 'text'" class="lib-img-center">
												<img style="width: auto" src="assets/img/lib-content.png" alt="">
											</div>

											<div *ngIf="!discoverContent.cover_image && discoverContent.type == 'image_file'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + discoverContent.content_data[0].image + ')' }"></div>

											<div *ngIf="discoverContent.cover_image && discoverContent.type == 'text'" style="display: flex; justify-content: center; align-items: center;" class="lib-img-center">
											  <span style="font-size: 50px;" class="emoji-icon">{{ convertUnicodeToEmoji(discoverContent.cover_image) }}</span>
											</div>

											<div *ngIf="discoverContent.cover_image && discoverContent.type == 'image_url'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + discoverContent.cover_image + ')' }"></div>

											<div class="lib-user-info-name">
												<span class="content-title">{{discoverContent.title}}</span>

												<span class="content-counts">{{discoverContent.content_data.length}}</span>
											</div>
										</div>

									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="show-library-content" [@slideInOutAnimation]="showLibraryContent ? 'in' : 'out'">
			<button type="button" class="close" (click)="closeToggleLibraryContent()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
			<ol class="grid-list" *ngIf="contentType == 'text'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'even-row': i % 2 === 0, 'odd-row': i % 2 !== 0 }">
			    <span>{{contentTextData.text_data}}</span>
			  </li>
			</ol>

			<ul class="horizontal-list" *ngIf="contentType == 'image_file'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'first-row': i < 3, 'second-row': i >= 3 }">
			    <img src="{{contentTextData.image}}" alt="" />
			  </li>
			</ul>

			<ul class="horizontal-list" *ngIf="contentType == 'image_url'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'first-row': i < 3, 'second-row': i >= 3 }">
			    <img src="{{contentTextData.image_content}}" alt="" />
			  </li>
			</ul>

		</div>

		<div class="discover-add-to-lib" *ngIf="showAddToLibSection">
			<div class="alert alert-dark" style="border-radius: 30px;">

				<span *ngIf="!showAddToLibButton" class="library-class" type="button" id="notice-btn-close" data-bs-dismiss="alert" (click)="deleteMultipleLibraryContent()">
					<svg style="margin-right: 10px; margin-top: -3px;" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<g id="Icons/Delete-Black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					   <g id="Delete" transform="translate(4.000000, 5.000000)" stroke="#FFFFFF">
					       <path d="M13.2631579,14.0210526 L2.65263158,14.0210526 C2.23351579,14.0210526 1.89473684,13.6822737 1.89473684,13.2631579 L1.89473684,1.1368421 C1.89473684,0.71848421 2.23351579,0.378947369 2.65263158,0.378947369 L13.2631579,0.378947369 C13.6822737,0.378947369 14.0210526,0.71848421 14.0210526,1.1368421 L14.0210526,13.2631579 C14.0210526,13.6822737 13.6822737,14.0210526 13.2631579,14.0210526 Z" id="Stroke-1"></path>
					       <line x1="5.3229979" y1="5.30412631" x2="5.30905262" y2="11.3672842" id="Stroke-3" stroke-linecap="round" stroke-linejoin="round"></line>
					       <line x1="10.5690694" y1="5.30412631" x2="10.5551242" y2="11.3672842" id="Stroke-5" stroke-linecap="round" stroke-linejoin="round"></line>
					       <line x1="15.5368421" y1="2.9368421" x2="0.378947369" y2="2.9368421" id="Stroke-7" stroke-linecap="round"></line>
					    </g>
					  </g>
					</svg>
					<span>Remove</span>
				</span>

				<span *ngIf="showAddToLibButton" class="library-class" type="button" id="notice-btn-close" data-bs-dismiss="alert" (click)="addDiscoverToLibrary()">
					<svg style="margin-right: 10px; margin-top: -3px;" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="DAM-Landing-Page-Copy-4" transform="translate(-1312.000000, -111.000000)">
											<g id="CTA-Copy-3" transform="translate(1296.000000, 96.000000)">
													<g id="Add" transform="translate(16.000000, 15.000000)">
															<rect id="Rectangle" x="0" y="0" width="18" height="18" rx="4"></rect>
															<g id="Group-3" transform="translate(3.000000, 3.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
																	<line x1="6" y1="0" x2="6" y2="12" id="Path-8"></line>
																	<line x1="6" y1="0.315789474" x2="6" y2="11.6842105" id="Path-8-Copy" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></line>
															</g>
													</g>
											</g>
									</g>
							</g>
					</svg>
					<span>Add to library</span>
				</span>

				<span class="cancel-class" type="button" id="notice-btn-close" data-bs-dismiss="alert" (click)="cancelUsersSelection()" mat-raised-button #tooltip="matTooltip"
				matTooltip="Close"
				matTooltipPosition="above"
				matTooltipClass="custom-tooltip">
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
					<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
					</svg>
				</span>
			</div>
		</div>

		<div class="loader-scenarios" *ngIf="showTopRightLoader">
			<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
		</div>

		<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
			<span class="ant-avatar-selected">
				<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</span>
			<p>{{successfullMessage}}</p>
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
			<p>{{sendSuccessfulErrorMessage}}</p>
		</div>
	</div>
</section>

<section *ngIf="searchLibrarySection">
	<div class="main-container">
		<div class="center-container vectors-section" style="padding-left: 50px;">
			<div class="">
				<div class="homepage-heading">
					<div class="homepage-heading_">
						<div class="homepage-heading-title">
							<h4 class="lib-library-txt" [ngClass]="{'selected-lib-text': isSelected[0], 'unselected-lib-text': !isSelected[0]}" (click)="myLibraryClick(0)">My Library</h4>
							<h4 class="lib-discover-txt" [ngClass]="{'selected-lib-text': isSelected[1], 'unselected-lib-text': !isSelected[1]}" (click)="discoverClick(1)">Discover</h4>
							<h4 class="lib-discover-txt" [ngClass]="{'selected-lib-text': isSelected[2], 'unselected-lib-text': !isSelected[2]}">Search</h4>
						</div>
					</div>
				</div>

				<div class="library-section">

					<div class="no-illus-img" *ngIf="!searchLibraryContent">
						<img style="width: 200px;" src="assets/img/lost.png">
						<div><label style="font-size: 16px; color: #000000;">No results found!</label></div>
					</div>

					<div class="row" *ngIf="searchLibraryContent">
						<div class="team-div">
							<ul *ngFor="let imagesContent of searchLibraryList">
								<li style="width: 100%;">
									<!-- [class.selected]="imagesContent.selected" (click)="toggleDiscoverSelection(imagesContent)" -->
									<div class="library-main-area">

										<div class="img-area" *ngIf="imagesContent.owner == 'Crafttor'">
											<img src="assets/img/crafttor-lib.svg" class="crafttor-lib-img">
										</div>

										<div data-toggle="dropdown" class="three-dots-area">
											<span class="anticon img-more-options">
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="6" cy="12" r="2" fill="#ffffff"/>
												<circle cx="12" cy="12" r="2" fill="#ffffff"/>
												<circle cx="18" cy="12" r="2" fill="#ffffff"/>
												</svg>
											</span>

											<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="more-option-section" (click)="openLibEditTagsDialog(imagesContent.id, imagesContent)">
														 <img src="assets/img/edit-icon.svg" alt="">
														 <a class="text" href="javscript:;" style="margin-top: 3px;">Edit tags</a>
													 </li>

													 <li class="more-option-section" *ngIf="imagesContent.owner == 'Crafttor'" (click)="deleteLibraryContent(imagesContent.id)">
														 <img src="assets/img/delete-red.svg" alt="">
														 <a style="color: #eb1313" class="text" href="javscript:;">Remove</a>
													 </li>

													 <li class="more-option-section" *ngIf="imagesContent.owner != 'Crafttor'" (click)="deleteLibraryContent(imagesContent.id)">
														 <img src="assets/img/delete-red.svg" alt="">
														 <a style="color: #eb1313" class="text" href="javscript:;">Delete</a>
													 </li>
												</ul>
											</div>
										</div>

										<div class="text-center" (click)="toggleLibraryContent(imagesContent.content_data, imagesContent.type)">
											<div *ngIf="!imagesContent.cover_image && imagesContent.type == 'text'" class="lib-img-center">
												<img style="width: auto" src="assets/img/lib-content.png" alt="">
											</div>

											<div *ngIf="!imagesContent.cover_image && imagesContent.type == 'image_file'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + imagesContent.content_data[0].image + ')' }"></div>

											<div *ngIf="imagesContent.cover_image && imagesContent.type == 'text'" style="display: flex; justify-content: center; align-items: center;" class="lib-img-center">
											  <span style="font-size: 50px;" class="emoji-icon">{{ convertUnicodeToEmoji(imagesContent.cover_image) }}</span>
											</div>

											<div *ngIf="imagesContent.cover_image && imagesContent.type == 'image_url'" class="lib-img-center" [ngStyle]="{ 'background-image': 'url(' + imagesContent.cover_image + ')' }"></div>

											<div class="lib-user-info-name">
												<span class="content-title">{{imagesContent.title}}</span>

												<span class="content-counts">{{imagesContent.content_data.length}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="show-library-content" [@slideInOutAnimation]="showLibraryContent ? 'in' : 'out'">
			<button type="button" class="close" (click)="closeToggleLibraryContent()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
			<ol class="grid-list" *ngIf="contentType == 'text'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'even-row': i % 2 === 0, 'odd-row': i % 2 !== 0 }">
			    <span>{{contentTextData.text_data}}</span>
			  </li>
			</ol>

			<ul class="horizontal-list" *ngIf="contentType == 'image_file'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'first-row': i < 3, 'second-row': i >= 3 }">
			    <img src="{{contentTextData.image}}" alt="" />
			  </li>
			</ul>

			<ul class="horizontal-list" *ngIf="contentType == 'image_url'">
			  <li *ngFor="let contentTextData of libraryTextContent; let i = index" [ngClass]="{ 'first-row': i < 3, 'second-row': i >= 3 }">
			    <img src="{{contentTextData.image_content}}" alt="" />
			  </li>
			</ul>

		</div>

		<div class="loader-scenarios" *ngIf="showTopRightLoader">
			<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
		</div>

		<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
			<span class="ant-avatar-selected">
				<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</span>
			<p>{{successfullMessage}}</p>
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
			<p>{{sendSuccessfulErrorMessage}}</p>
		</div>
	</div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 50px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':addContentStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end; cursor: pointer;" type="button" class="close" (click)="closeContentDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
			<div class="modal-body">
			<div class="mt-2 share-class-permit profile-dialog-area" style="position: relative;">
				<h2 style="margin-top: -20px;" class="profile-dialog-header">Create Library</h2>

				<div class="text-image-radio">
					<input type="radio" name="subscriptionss" id="text" value="text" [checked]="radioText" (click)="textClick()">
					<label for="text" style="margin-left: 8px;">Text</label>
					<input style="margin-left: 20px;" type="radio" name="subscriptionss" id="images" value="images" [checked]="radioImages" (click)="imagesClick()">
					<label for="images" style="margin-left: 8px;">Image</label>
				</div>
				<div class="form-wrapper">
					<form class="row g-3" [formGroup]="addContentTextForm" *ngIf="!radioImages && radioText">
						<div class="col-md-12">
							<label class="form-labels">Name<span>*</span></label>

							<div class="" style="display: flex;">
								<input style="width: 86%" [(ngModel)]="contentTextName" id="textinput" formControlName="textname" autocomplete="off" type="text" placeholder="Add library name" class="form-control input-md" required #libContentData>

								<button class="lib-emoji" (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">
									<svg *ngIf="!selectedEmoji" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M9.12002 9.12002V8.12002C8.56774 8.12002 8.12002 8.56774 8.12002 9.12002H9.12002ZM9.21565 9.12002H10.2156C10.2156 8.56774 9.76793 8.12002 9.21565 8.12002V9.12002ZM14.88 9.12002V8.12002C14.3277 8.12002 13.88 8.56774 13.88 9.12002H14.88ZM14.965 9.12002H15.965C15.965 8.56774 15.5173 8.12002 14.965 8.12002V9.12002ZM9.21565 9.1969V10.1969C9.76793 10.1969 10.2156 9.74918 10.2156 9.1969H9.21565ZM9.12002 9.1969H8.12002C8.12002 9.74918 8.56774 10.1969 9.12002 10.1969V9.1969ZM14.965 9.1969V10.1969C15.5173 10.1969 15.965 9.74918 15.965 9.1969H14.965ZM14.88 9.1969H13.88C13.88 9.74918 14.3277 10.1969 14.88 10.1969V9.1969ZM9.52226 14.3929C9.23157 13.9233 8.61525 13.7782 8.14565 14.0689C7.67605 14.3596 7.53101 14.9759 7.82169 15.4455L9.52226 14.3929ZM16.1784 15.4455C16.469 14.9759 16.324 14.3596 15.8544 14.0689C15.3848 13.7782 14.7685 13.9233 14.4778 14.3929L16.1784 15.4455ZM20.6 12C20.6 16.7497 16.7497 20.6 12 20.6V22.6C17.8542 22.6 22.6 17.8542 22.6 12H20.6ZM12 20.6C7.25037 20.6 3.40002 16.7497 3.40002 12H1.40002C1.40002 17.8542 6.14581 22.6 12 22.6V20.6ZM3.40002 12C3.40002 7.25037 7.25037 3.40002 12 3.40002V1.40002C6.14581 1.40002 1.40002 6.14581 1.40002 12H3.40002ZM12 3.40002C16.7497 3.40002 20.6 7.25037 20.6 12H22.6C22.6 6.14581 17.8542 1.40002 12 1.40002V3.40002ZM9.12002 10.12H9.21565V8.12002H9.12002V10.12ZM14.88 10.12H14.965V8.12002H14.88V10.12ZM8.21565 9.12002V9.1969H10.2156V9.12002H8.21565ZM9.21565 8.1969H9.12002V10.1969H9.21565V8.1969ZM10.12 9.1969V9.12002H8.12002V9.1969H10.12ZM13.965 9.12002V9.1969H15.965V9.12002H13.965ZM14.965 8.1969H14.88V10.1969H14.965V8.1969ZM15.88 9.1969V9.12002H13.88V9.1969H15.88ZM12 15.8C10.9702 15.8 10.0524 15.2493 9.52226 14.3929L7.82169 15.4455C8.69145 16.8506 10.2315 17.8 12 17.8V15.8ZM14.4778 14.3929C13.9477 15.2493 13.0298 15.8 12 15.8V17.8C13.7686 17.8 15.3086 16.8506 16.1784 15.4455L14.4778 14.3929Z" fill="black"/>
									</svg>
									<span *ngIf="selectedEmoji">{{ selectedEmoji }}</span>
								</button>
								<emoji-mart style="position: absolute; left: 460px; left 810px;" class="emoji-mart" *ngIf="isEmojiPickerVisible"
								(emojiClick)="addEmojiLib($event.emoji.native)" title="Choose your emoji"></emoji-mart>
							</div>

						</div>

						<div class="col-md-12 text-images-list-section">
					    <span class="clear-list" (click)="clearContentTextList()">Clear All</span>
					    <label class="form-labels">Content<span>*</span></label>

							<div class="content-txt-section">
						    <textarea *ngIf="!hideTextInputField" class="text-input-field" [formControl]="contentControl" placeholder="Write or paste your content" (input)="onInputChange($event)" [(ngModel)]="contentEditData"></textarea>
						    <span style="color: #a9a9a9; padding-left: 16px;" class="placeholder" *ngIf="pastedLines.length === 0"></span>
						    <ol *ngIf="pastedLines.length > 0 && hideTextInputField" class="text-ol-list">
						       <li *ngFor="let line of pastedLines; let i = index">{{ line }}</li>
						    </ol>
							</div>

						</div>

						<div class="col-3" style="margin-left: auto; display: flex;">
							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && pastedLines.length == 0 && libContentData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && pastedLines.length > 0 && !libContentData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && pastedLines.length == 0 && !libContentData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showLeaveLoader && pastedLines.length > 0 && libContentData.value" (click)="submitContentTextData()">Submit</button>
							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
						</div>
					</form>

					<form class="row g-3" [formGroup]="addContentImagesForm" *ngIf="radioImages && !radioText">

						<div class="col-md-12" style="position: relative;">
							<label class="form-labels">Name<span>*</span></label>
							<input [(ngModel)]="contentImageName" id="textinput" formControlName="imagesname" type="text" placeholder="Add library name" class="form-control input-md" required #libImagesData>
						</div>

						<div class="col-md-12 text-images-list-section">
							<label *ngIf="contentImageName" style="height: 40px;" class="clear-list">
								<input type="file" accept="image/png, image/jpg, image/jpeg" multiple (change)="onFileSelected($event)" />
								<span style="color: #2d7cff">Add Image</span>
							</label>
							<label *ngIf="!contentImageName" style="height: 40px;" class="clear-list">
								<span style="color: #A9A9A9">Add Image</span>
							</label>
							<!-- <span class="clear-list" (click)="clearContentImagesList()">Clear All</span> -->
							<label class="form-labels">Content Images<span>*</span></label>
							<div class="content-images-section">
								<span style="color: #a9a9a9; " class="placeholder" *ngIf="urlList.length === 0">Paste image urls or add image</span>
								<ng-container *ngIf="urlList.length > 0" class="ng-container">
									<div class="image-container" *ngFor="let url of urlList">
										<img [src]="url" alt="Image from URL">
									</div>
								</ng-container>
							</div>
						</div>

						<div class="col-md-6" style="margin-left: auto; display: flex;">
							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn lib-img-upload-btn" (click)="closeContentDialog()">Cancel</button>

							<!-- <label *ngIf="contentImageName" style="width: 140px; height: 40px;" class="btn lib-img-upload-btn">
								<input type="file" accept="image/*" multiple (change)="onFileSelected($event)" />
								<span>Add Image</span>
							</label>

							<label *ngIf="!contentImageName" style="width: 140px; height: 40px;" class="btn lib-img-upload-disable-btn">
								<span>Add Image</span>
							</label> -->

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && urlList.length == 0 && libImagesData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && urlList.length > 0 && !libImagesData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn save-disable-btn" *ngIf="!showLeaveLoader && urlList.length == 0 && !libImagesData.value">Submit</button>

							<button style="width: 110px; height: 40px;" id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showLeaveLoader && urlList.length > 0 && libImagesData.value" (click)="submitContentImagesData()">Submit</button>

							<button style="width: 110px; height: 39px;" id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
						</div>

					</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':goProPlanStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
			<button type="button" class="close" (click)="closeGoProDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
				<div class="mt-2 share-class-permit">
					<h3 class="share-a-link">Upgrade your plan</h3>
					<div class="d-flex email-input-share-link mt-3">
						<h4 class="upgrade-free-plan">You are currently on the Free plan. Upgrade to a premium plan to create your own content.</h4>
					</div>
					<div class="rename-save-btn">
						<button class="button cancel-button" (click)="closeGoProDialog()">Cancel</button>
						<button class="button" (click)="goToSubscription()">Upgrade</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 100px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':assetEditTagsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
		<button type="button" class="close" (click)="closeEditTagsDialog()" data-dismiss="modal" aria-label="Close">
			<img src="assets/img/cross.svg">
		</button>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Edit tags</h3>
			<div class="d-flex email-input-share-link mt-3">
				<form [formGroup]="tagsForm" class="custom-form search-area-field" (ngSubmit)="onSubmitMultipleTags()" #heroForm="ngForm">
					<div class="edit-tag-field">
						<div class="mat-chip-main" *ngIf="editTagsList.length > 0">
							<ul class="mat-chip-list-main">
								<li class="mat-chip-list" *ngFor="let addedTags of editTagsList; let i = index">
									<span class="chip-txt"><a>{{ addedTags }}</a>
										<span (click)="removeAddedTags(i)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
											<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="#a9a9a9" aria-hidden="true">
												<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
												</path>
											</svg>
										</span>
									</span>
								</li>
							</ul>
						</div>
						<input formControlName="edittags" type="text" class="" placeholder="Add tags">
					</div>
				</form>
			</div>
			<p>{{editTagsError}}</p>
			<div class="rename-save-btn">
				<button class="button cancel-button" (click)="closeEditTagsDialog()">Cancel</button>
				<button *ngIf="!showEditTagsLoader" class="button create-rename-link" (click)="editMultipleTags()">Add</button>
				<button *ngIf="showEditTagsLoader" class="button create-rename-link"><img style="height: 18px;" src="assets/img/img-up-white.svg"></button>
			</div>

			<div class="added-tags-library" *ngIf="addedTagsList.length > 0">
				<h4>Added Tags</h4>
				<ul class="capsule-list lib-capsule">
					<li class="capsule" *ngFor="let tag of addedTagsList; let i=index">
						<span class="chip-txt"><a>{{tag}}</a>
							<span (click)="removeLibraryAddedTags(tag, i)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
								<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="18" height="18" fill="#a9a9a9" aria-hidden="true">
									<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
									</path>
								</svg>
							</span>
						</span>
					</li>
				</ul>
			</div>
		</div>
		</div>
	</div>
</div>
</div>
